var _path, _mask, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0909 8.81824C16.2466 8.81824 15.4852 8.45686 14.9534 7.88061L9.69243 10.8798C9.77423 11.1481 9.81824 11.4326 9.81824 11.7273C9.81824 12.0218 9.77427 12.3063 9.69255 12.5744L14.9537 15.5737C15.4855 14.9976 16.2467 14.6364 17.0909 14.6364C18.6954 14.6364 20 15.9411 20 17.5455C20 19.1498 18.6954 20.4546 17.0909 20.4546C15.4865 20.4546 14.1819 19.1498 14.1819 17.5455C14.1819 17.3078 14.2105 17.0766 14.2646 16.8553L8.93262 13.8156C8.40868 14.3234 7.6948 14.6364 6.90905 14.6364C5.30478 14.6364 4 13.3317 4 11.7273C4 10.1229 5.30478 8.81824 6.90905 8.81824C7.69467 8.81824 8.40845 9.13106 8.93237 9.6387L14.2645 6.59886C14.2105 6.37767 14.1819 6.14665 14.1819 5.90905C14.1819 4.30478 15.4865 3 17.0909 3C18.6954 3 20 4.30478 20 5.90905C20 7.51346 18.6954 8.81824 17.0909 8.81824Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0909 8.81824C16.2466 8.81824 15.4852 8.45686 14.9534 7.88061L9.69243 10.8798C9.77423 11.1481 9.81824 11.4326 9.81824 11.7273C9.81824 12.0218 9.77427 12.3063 9.69255 12.5744L14.9537 15.5737C15.4855 14.9976 16.2467 14.6364 17.0909 14.6364C18.6954 14.6364 20 15.9411 20 17.5455C20 19.1498 18.6954 20.4546 17.0909 20.4546C15.4865 20.4546 14.1819 19.1498 14.1819 17.5455C14.1819 17.3078 14.2105 17.0766 14.2646 16.8553L8.93262 13.8156C8.40868 14.3234 7.6948 14.6364 6.90905 14.6364C5.30478 14.6364 4 13.3317 4 11.7273C4 10.1229 5.30478 8.81824 6.90905 8.81824C7.69467 8.81824 8.40845 9.13106 8.93237 9.6387L14.2645 6.59886C14.2105 6.37767 14.1819 6.14665 14.1819 5.90905C14.1819 4.30478 15.4865 3 17.0909 3C18.6954 3 20 4.30478 20 5.90905C20 7.51346 18.6954 8.81824 17.0909 8.81824Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#9CA4B5"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.13417614.svg";
export { ForwardRef as ReactComponent };